import { ServiceResponse } from '@foundation/foundation-core-sdk';
import { isArray, isObject } from 'lodash';
import { OperatorFunction, filter, map } from 'rxjs';

/**
 * TODO(abalkar): Add comments.
 */
export function filterNotNull<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter((value: T): value is NonNullable<T> => value != null);
}

/**
 * TODO(abalkar): Add comments.
 */
export function filterIsString<T>(): OperatorFunction<T, string> {
  return filter((value: any): value is string => typeof value == 'string');
}

/**
 * TODO(abalkar): Add comments.
 */
export function mapIsObject<T>(): OperatorFunction<T, boolean> {
  return map((value: T): boolean => isObject(value) && !isArray(value));
}

/**
 * TODO(abalkar): Add comments.
 */
export function mapServiceResponseContent<T>(): OperatorFunction<ServiceResponse<T> | null, T | null> {
  return map((serviceResponse: ServiceResponse<T>): T => {
    if (serviceResponse == null) {
      throw new Error('ServiceResponse is null');
    }

    if (serviceResponse.content == null) {
      throw new Error('ServiceResponse content is null');
    }

    return serviceResponse.content;
  });
}
